<template>
  <div class="row">
    <div class="col-12">
      <read-point-table />
    </div>
  </div>
</template>

<script>
import ReadPointTable from "@/views/components/readPoints/table";
export default {
  name: "ReadPointsList",
  components: { ReadPointTable },
};
</script>
